import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TopNav from "./topnav/TopNav";

const Dashboard = () => {
  const getTotalProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/total/count`
      );
      const productCount = response.data.totalProductCount;
      console.log("response.data", response.data.totalProductCount);
      return productCount;
    } catch (error) {
      console.error("Failed to get total products:", error);
      throw error;
    }
  };
  const [totalProducts, setTotalProducts] = useState(0);

  useEffect(() => {
    getTotalProducts()
      .then((productCount) => {
        setTotalProducts(productCount);
      })
      .catch((error) => {
        console.error("Error getting total products:", error);
      });
  }, []);

  const [invoices, setInvoices] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/invoices/unconfirmedCount`
        );
        const fetchedInvoices = response.data.count;
        setTotalOrders(fetchedInvoices);
      } catch (error) {
        console.error("Failed to fetch invoices:", error);
      }
    };

    fetchInvoices();
  }, []);

  const [totalRevenue, setTotalRevenue] = useState(0);
  const getTotalByDate = async (date) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/invoices/totalInAWeek`
      );
      const total = response.data.total;
      setTotalRevenue(total);
    } catch (error) {
      toast.error("Error retrieving total revenue.");
    }
  };

  useEffect(() => {
    const date = new Date().toISOString().split("T")[0]; // Ngày hiện tại
    getTotalByDate(date);
  }, []);

  const [totalCustomers, setTotalCustomers] = useState(0);

  const getTotalCustomers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/totalUser/count`
      );
      const customerCount = response.data.totalUserCount;
      return customerCount;
    } catch (error) {
      console.error("Failed to get total customers:", error);
      throw error;
    }
  };
  useEffect(() => {
    getTotalCustomers()
      .then((customerCount) => {
        setTotalCustomers(customerCount);
      })
      .catch((error) => {
        console.error("Error getting total customers:", error);
      });
  }, []);

  const [totalCancelledInvoices, setTotalCancelledInvoices] = useState(0);
  const getTotalCancelledInvoices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/invoices/cancelledCount`
      );
      const cancelledInvoicesCount = response.data.count;
      return cancelledInvoicesCount;
    } catch (error) {
      console.error("Failed to get total cancelled invoices:", error);
      throw error;
    }
  };

  useEffect(() => {
    getTotalCancelledInvoices()
      .then((cancelledInvoicesCount) => {
        setTotalCancelledInvoices(cancelledInvoicesCount);
      })
      .catch((error) => {
        console.error("Error getting total cancelled invoices:", error);
      });
  }, []);

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
            <p className="text-gray-600 mt-1">Tổng quan hệ thống quản lý</p>
          </div>
          <TopNav />
        </div>
      </div>

      <div className="overflow-y-auto h-[calc(100vh-100px)] px-6 py-6">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {/* Left Stats - 2/3 width */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Sản phẩm */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Sản phẩm
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Tổng sản phẩm có trong kho
                  </p>
                  <div className="text-3xl font-bold text-blue-600 mt-3">
                    {totalProducts}
                  </div>
                </div>
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Đơn hàng */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Đơn hàng
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Tổng đơn hàng cần xác nhận
                  </p>
                  <div className="text-3xl font-bold text-orange-600 mt-3">
                    {totalOrders}
                  </div>
                </div>
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-orange-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Hủy đơn hàng */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Hủy đơn hàng
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Tổng đơn hàng đã hủy
                  </p>
                  <div className="text-3xl font-bold text-red-600 mt-3">
                    {totalCancelledInvoices}
                  </div>
                </div>
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Khách hàng */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Khách hàng
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Tổng số khách hàng
                  </p>
                  <div className="text-3xl font-bold text-green-600 mt-3">
                    {totalCustomers}
                  </div>
                </div>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Revenue Card - 1/3 width */}
          <div className="lg:col-span-1">
            <div className="bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 rounded-xl shadow-lg text-white p-6 h-full relative overflow-hidden">
              {/* Background decoration */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full transform translate-x-16 -translate-y-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-5 rounded-full transform -translate-x-12 translate-y-12"></div>

              <div className="relative z-10 h-full flex flex-col justify-between">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                      />
                    </svg>
                  </div>
                  <div className="text-right">
                    <div className="text-xs uppercase tracking-wider opacity-75">
                      Revenue
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="text-center flex-1 flex flex-col justify-center">
                  <h3 className="text-lg font-medium mb-2 opacity-90">
                    Doanh thu tuần này
                  </h3>
                  <div className="text-3xl font-bold mb-1">
                    {totalRevenue.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })}
                  </div>
                  <div className="text-sm opacity-75">
                    {new Date().toLocaleDateString("vi-VN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </div>
                </div>

                {/* Footer indicator */}
                <div className="flex items-center justify-center mt-4">
                  <div className="flex items-center text-sm opacity-75">
                    <svg
                      className="w-4 h-4 mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                      />
                    </svg>
                    <span>7 ngày gần nhất</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="max-w-md">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">
              Thao tác nhanh
            </h2>
            <div className="space-y-3">
              <button
                className="w-full flex items-center space-x-3 p-3 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors group"
                onClick={() => navigate("/admin/products/add")}
              >
                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </div>
                <div className="text-left">
                  <div className="font-medium text-gray-900">
                    Thêm sản phẩm mới
                  </div>
                  <div className="text-sm text-gray-500">
                    Tạo sản phẩm cho cửa hàng
                  </div>
                </div>
              </button>

              <button
                className="w-full flex items-center space-x-3 p-3 rounded-lg bg-orange-50 hover:bg-orange-100 transition-colors group"
                onClick={() => navigate("/admin/orders")}
              >
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
                <div className="text-left">
                  <div className="font-medium text-gray-900">Xem đơn hàng</div>
                  <div className="text-sm text-gray-500">
                    Quản lý đơn hàng mới
                  </div>
                </div>
              </button>

              <button
                className="w-full flex items-center space-x-3 p-3 rounded-lg bg-green-50 hover:bg-green-100 transition-colors group"
                onClick={() => navigate("/admin/customers")}
              >
                <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                    />
                  </svg>
                </div>
                <div className="text-left">
                  <div className="font-medium text-gray-900">
                    Quản lý khách hàng
                  </div>
                  <div className="text-sm text-gray-500">
                    Xem danh sách khách hàng
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
